import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { BUSINESS_PARTNER_EXPORT_ID, BUSINESS_PARTNER_TITLE } from './business-partner.constants';
import { BusinessPartnerService } from '../business-partner.service';
import { BusinessPartnerListJsonExportProcessor } from './business-partner-list-json';
import { BusinessPartnerListExcelExportProcessor } from './business-partner-list-excel';

@Injectable()
export class BusinessPartnerExport {
  constructor(
    private exportService: ExportService,
    private businessPartnerService: BusinessPartnerService,
  ) {}

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number, geolocationPoint: string) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: BUSINESS_PARTNER_EXPORT_ID,
      title: BUSINESS_PARTNER_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      processor: format === ExportFileFormat.JSON
      ? new BusinessPartnerListJsonExportProcessor()
      : new BusinessPartnerListExcelExportProcessor(),
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.businessPartnerService.findByFilter(buildQuery(
          seed(this.businessPartnerService.currentFilter),page(currentPage, pageSize)
        ), geolocationPoint , { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => { ctx.add(item); });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(BUSINESS_PARTNER_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
